import { FC } from 'react';
import Button from '../Button/Button';
import { ExportProps } from './Export.types';

const Export: FC<ExportProps> = ({ columnHeaders, rowData, buttonLabel = 'Export', testId }) => {
  const handleClick = () => {
    setLocalStorage();
    window.open('/pdf');
  };

  const setLocalStorage = () => {
    const data = JSON.stringify({
      columnHeaders,
      rowData,
    });
    localStorage.setItem('pdfData', data);
  };

  return <Button testId={testId} onClick={handleClick} label={buttonLabel} />;
};

export default Export;
